import { render, staticRenderFns } from "./CommonsNavigationButton.vue?vue&type=template&id=3abe175e&scoped=true&"
import script from "./CommonsNavigationButton.vue?vue&type=script&lang=js&"
export * from "./CommonsNavigationButton.vue?vue&type=script&lang=js&"
import style0 from "./CommonsNavigationButton.vue?vue&type=style&index=0&id=3abe175e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe175e",
  null
  
)

export default component.exports